<template>
  <div :class="navbarbox">
    <div class="navbar-body">
      <div href="#" class="navbar-brand" v-if="isMobile && tabindex != 0" @click="goBack">
        <img src="../assets/mend_fanhui.png" class="return" alt="">
      </div>
      <div href="#" class="navbar-brand">
        <img class="logo" src="../assets/logo_icon.png" alt="" style="width: 100%; height: 52px;margin-top: 16px;">
      </div>
      <ul class="navbar-right" v-if="!isMobile">
        <li v-for="(item, index) in tabList" :key="index" @click="getLink(item.url, index)">
          <a href="javascript:void(0)" :class="tabindex == index ? 'active' : ''">{{ item.name }}</a>
        </li>
      </ul>
      <div v-if="isMobile">
        <img class="mend" @click="drawer = true" v-if="!drawer" src="../assets/mend.png" alt="">
        <img class="mend" @click="drawer = false" v-if="drawer" src="../assets/mend_colse.png" alt="">
      </div>
    </div>

    <!-- 手机端展示 -->
    <div class="popup" v-if="drawer">
      <el-menu :default-active="activeIndex" class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose">
        <div v-for="(item, index) in tabList" :key="item.title">
          <el-submenu :index="(index + '')" v-if="item.children.length > 0">
            <template slot="title">
              <span>{{ item.name }}</span>
            </template>
            <el-menu-item-group>
              <el-menu-item :index="(index + '-' + idx)" v-for="(items, idx) in item.children" :key="idx"
                @click="solveScheme(idx, index + '-' + idx)" style="font-size: 14px;">{{ idx + 1 }} {{ items }}</el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-menu-item :index="(index + '')" v-else @click="getLink(item.url, index)">
            <span slot="title">{{ item.name }}</span>
          </el-menu-item>
        </div>
      </el-menu>
      <div style="height: 40px;background-color: white;"></div>
      <!-- <transition name="el-fade-in-linear">
        <div class="popup-body">
          <ul>
            <li v-for="(item, index) in tabList" :key="index" @click="getLink(item.url, index)">
              <a href="javascript:void(0)" :class="tabindex == index ? 'active' : ''">{{ item.name }}</a>
            </li>
          </ul>
        </div>
      </transition> -->
    </div>


  </div>
</template>

<script>
import { getisMobile } from '@/utils/utils'
// import { mapState, } from 'vuex';
import { mapState, mapActions } from 'vuex';

export default {
  name: 'HelloWorld',

  computed: {
    ...mapState(['activeIndex'])
  }

  ,
  data() {
    return {
      // activeIndex:"3",
      isMobile: getisMobile(),
      tabList: [
        { name: '首页', url: '/', children: [] },
        { name: '解决方案', url: '/scheme', children: ['音视频一站式解决方案', 'DevOps解决方案', 'OTT视频CDN解决方案', 'OTT综合业务解决方案', 'OTT视频编码解决方案', '播放器解决方案'] },
        { name: '关于我们', url: '/index?id=3', children: [] },
        { name: '联系我们', url: '/index?id=4', children: [] },
      ],
      tabindex: 0,
      backIndex: 0,
      navbarbox: 'navbars animate__animated animate__fadeInDown',
      drawer: false,
    }
  },
  watch: {
    $route(to) {
      console.log(to.query, 'idx0000')
      // this.activeIndex = to.query.id
      if (to.path == '/index') {
        // this.activeIndex = to.query.id
        //  this.tabindex = 0
      }
    },
  },

  mounted() {
    console.log(this.$store.state.activeIndex, '0000')


    window.addEventListener('scroll', this.handleScroll);
    this.tabList.map((item, index) => {
      if (item.url == this.$route.path) {
        console.log()
        this.tabindex = index
      }
    })
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    ...mapActions(['setMyData']),

    goBack() {
      this.$router.push('/');
    },

    getLink(url, index) {
      this.tabindex = index;
      this.$router.push(url);
      this.$store.commit('setMyData', index.toString());
      this.drawer = false
      if (index == 2) {
        this.toModel()
        return
      }
      if (index == 3) {
        this.toModelbox()
        return
      }
    },

    solveScheme(index, idx) {
      this.$router.push("/scheme?idx=" + index);
      this.$store.commit('setMyData', idx.toString());
      this.drawer = false
    },

    handleScroll() {
      const scrollPosition = window.scrollY || document.documentElement.scrollTop;
      if (scrollPosition === 0) {
        this.backIndex = 0
        this.navbarbox = 'navbars '
      } else {
        this.backIndex = 1;
        this.navbarbox = 'navbars navbarx'
      }
    },

    toModel() {
      // 等待dom加载完毕后执行
      this.$nextTick(() => {
        // 1,通过形参获取当前需要的dom
        let targetbox = document.getElementById('targetElement');
        // 2,获取该dom距离页头的高度
        this.target = targetbox.offsetTop;
        // 3,执行页面跳转
        document.documentElement.scrollTop = this.target;
      })
    },

    toModelbox() {
      // 等待dom加载完毕后执行
      this.$nextTick(() => {
        // 1,通过形参获取当前需要的dom
        let targetbox = document.getElementById('contact');
        // 2,获取该dom距离页头的高度
        this.target = targetbox.offsetTop;
        // 3,执行页面跳转
        document.documentElement.scrollTop = this.target;
      })
    },

    handleOpen() {

    },
    handleClose() {

    }

  }
}
</script>

<style lang="scss">
@import 'animate.css';

.navbars {
  display: flex !important;
  justify-content: space-between !important;
  background: white;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 9999999;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);

  .navbar-body {
    max-width: 1400px;
    min-width: 1400px;
    margin: 0 auto;
    display: flex;
    line-height: 60px;

    .navbar-right {
      display: flex;

      li {
        list-style: none;
        width: 120px;
        text-align: center;
        color: #666666;
        padding-top: 10px;
        font-size: 18px;

        a {
          text-decoration: none;
          color: #666666;
        }
      }

      .active {
        font-weight: bold;
        color: #0052D9;
      }
    }
  }
}

.navbarx {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  z-index: 999 !important;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
}

.popup {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 100VH;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 9;
  padding-top: 84px;

  .popup-body {
    background-color: white;
    height: auto;
    padding: 20px 0 40px;
    border-top: 3px solid #0042C8;

    ul {
      padding-left: 20px;

      li {
        list-style: none;
        border-bottom: 1px solid #D9D9D9;

        a {
          color: #000000;
          line-height: 46px;
          text-decoration: none;
          font-size: 14px;
        }
      }
    }

    .active {
      font-weight: bold;
      color: #0052D9;
    }
  }
}

@media screen and (max-width: 1200px) and (min-width: 600px) {
  .navbar-body {
    max-width: 1000px !important;
    min-width: 1000px !important;
  }
}

@media screen and (max-width: 600px) {
  .navbars {
    .navbar-body {
      padding: 0 20px;
      height: 84px;
      width: 100% !important;
      background-color: white;
      z-index: 999;
      max-width: auto;
      min-width: auto;
      display: flex;
      justify-content: space-between;

      .mend {
        width: 30px;
        height: 30px;
        position: relative;
        top: 38px;
        right: 0px;
        display: block;
      }

      .navbar-brand {
        display: flex;
        justify-content: space-between;
        position: relative;

        .return {
          position: relative;
          top: 32px;
          width: 34px !important;
          height: 34px !important;
          margin-right: 14px;
        }

        .logo {
          margin-top: 30px !important;
          height: 40px !important;
          width: 120px !important;

        }
      }

      .navbar-right {
        // display: none !important;
      }

    }
  }

}
</style>
